export const SUPPORT_PREFILL_STORAGE_KEY = 'support-form-prefill'

export type SupportFormPrefill = {
  subjectSlug: string
  name?: string
  email?: string
  phone?: string
  pedido?: string
  nf?: string
  produto?: string
  devolucao?: string
  documento?: string
  descricao?: string
}

export const writeSupportFormPrefill = (prefill: SupportFormPrefill) => {
  if (typeof window === 'undefined') return

  try {
    window.sessionStorage.setItem(SUPPORT_PREFILL_STORAGE_KEY, JSON.stringify(prefill))
  } catch {
    // ignora falha de persistencia temporaria
  }
}

export const readSupportFormPrefill = (): SupportFormPrefill | null => {
  if (typeof window === 'undefined') return null

  try {
    const raw = window.sessionStorage.getItem(SUPPORT_PREFILL_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as SupportFormPrefill
    if (!parsed || typeof parsed !== 'object' || !parsed.subjectSlug?.trim()) {
      window.sessionStorage.removeItem(SUPPORT_PREFILL_STORAGE_KEY)
      return null
    }
    return parsed
  } catch {
    window.sessionStorage.removeItem(SUPPORT_PREFILL_STORAGE_KEY)
    return null
  }
}

export const clearSupportFormPrefill = () => {
  if (typeof window === 'undefined') return

  try {
    window.sessionStorage.removeItem(SUPPORT_PREFILL_STORAGE_KEY)
  } catch {
    // ignora falha de limpeza temporaria
  }
}
